<template>
  <div>

    <VueSlickCarousel
        class="content-carrousel"
        v-bind="slickSettings"
    >
      <div class="content-carrousel-slide" v-for="(item, index) in items">
        <div class="inside-area">
          <!--<div class="image-area" v-if="item.image_url" :style="{'background-image': 'url(' + item.image_url + ')', 'width': '500px', 'height': '500px'}"></div>-->
          <picture v-if="item.image_url && item.image_url.length > 0" :style="{'max-width' : imageMaxWidth(item)}">
              <img v-lazy="item.image_url" class="image-area">
              <div class="spinner-border" role="status">
                <span class="visually-hidden"></span>
              </div>
          </picture>
          <div class="content-area" :style="{'max-width' : imageMaxWidth(item, true)}">
            <div class="caption" v-html="item.label"></div>
            <a v-if="item.href !== null && item.target !== 'modal'" :href="item.href" >{{readmore}}</a>
            <b-button v-if="item.target === 'modal'" v-b-modal="'carrosel-modal-' + _uid + '-' + index" class="btn btn-success">{{item.readMore}}</b-button>
          </div>
        </div>
      </div>
    </VueSlickCarousel>

    <div v-for="(item, index) in items" >
      <b-modal v-if="item.target === 'modal'" :id="'carrosel-modal-' + _uid + '-' + index" size="lg" hide-footer centered><div class="modal-body" v-html="item.modal"></div></b-modal>
    </div>

  </div>

</template>

<script>
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        components: { VueSlickCarousel },
        props: ['items', 'settings', 'readmore'],

        data: () => { return {
            currentFilter : '',
            slickSettings: {
                dots:true,
                dotsClass: "slick-dots custom-dot-class",
                arrows:true,
                autoplay: true,
                infinite:true,
                speed:200,
                variableWidth:true,
                adaptiveHeight: true,
                draggable: true,
                slidesToShow : 1,
                responsive: [
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1,
                      slidesPerRow: 1
                    }
                  }
                ]
            }
        }},
        mounted(){
          Object.keys(this.settings).forEach(function (item) {
            this.slickSettings[item] = this.settings[item];
          }.bind(this));
        },
        methods:{
          imageMaxWidth: function(item, textSide) {

            if (textSide === true && item.image_width !== null) {
              return (80 - parseInt(item.image_width)) + '%';
            }

            if(item.image_width !== null) {
              return item.image_width + '%'
            }
          }
        }
    }
</script>
